import React, { useState, useEffect, useContext } from 'react';
import { Button, Modal, ModalBody, ModalHeader, ModalFooter, UncontrolledTooltip } from 'reactstrap';
import { AppContext } from './../AppContext';
import { Paginacion } from './Paginacion';
import { UnidadConsulta } from './UnidadConsulta';
import { EvaluacionDetalle } from './EvaluacionDetalle';

import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

const TITLE = "Reportes de Retroalimentación Estudiantil";
const BASEURL = process.env.REACT_APP_API_URL;

const MySwal = withReactContent(Swal)

const UnidadEvaluacion = (props) => {

    const [total, setTotal] = useState(0);
    const [loading, setLoading] = useState(true);

    const [state, setState] = useState({
        unidad: "",
        anio: 0,
        termino: "",
        nombres: "",
        apellidos: "",
        page: 1,
        size: 10,
        unidades: [],
        anios: [],
        terminos: [],
    });

    const [paralelos, setParalelos] = useState([]);
    const [periodos, setPeriodos] = useState([]);

    const currentUser = useContext(AppContext).currentUser;

    const populateInitialData = async (user) => {
        const unidadesRol = user.roles.filter(r => r.role === "DECANO" || r.role === "SUBDECANO").map(r => r.scope);

        if (unidadesRol.length === 0) return;

        const initialUnidad = props.match.params["unidad"] || unidadesRol[0];

        const initialAnios = [];
        let initialPeriodos = [];

        if (periodos.length === 0) {
            const responsePeriodos = await fetch(`${BASEURL}/api/reporte-usuario/planificacion-periodo-unidad/${initialUnidad}`);
            const dataPeriodos = await responsePeriodos.json();

            initialPeriodos = [...initialPeriodos, ...dataPeriodos.datos];

            initialPeriodos.forEach(at => {
                if (!initialAnios.includes(at.anio)) {
                    initialAnios.push(at.anio);
                }
            });
        }

        const initialAnio = props.match.params["anio"] || (initialAnios.length > 0 ? initialAnios[0] : 0);
        const initialTerminos = [];

        initialPeriodos.filter(p => p.anio === initialAnio).forEach(at => {
            if (!initialTerminos.includes(at.termino)) {
                initialTerminos.push(at.termino);
            }
        });

        const initialTermino = props.match.params["termino"] || (initialTerminos.length > 0 ? initialTerminos[0] : "");
        const initialPage = props.match.params["page"] || state.page;
        const initialSize = props.match.params["size"] || state.size;

        props.history.push(`/unidad-evaluacion/${initialUnidad}/${initialAnio}/${initialTermino}/${initialPage}/${initialSize}`);
        setState(prevState => ({
            ...prevState,
            unidades: unidadesRol,
            anios: initialAnios,
            terminos: initialTerminos,
            unidad: initialUnidad,
            anio: initialAnio,
            termino: initialTermino
        }));
    };

    const populateData = async (user) => {
        const unidad = props.match.params["unidad"] || state.unidad;
        let anio = props.match.params["anio"] || state.anio;
        let termino = props.match.params["termino"] || state.termino;

        const page = parseInt(props.match.params["page"]) || state.page;
        const size = parseInt(props.match.params["size"]) || state.size;

        if (anio === 0 || unidad === "" || termino === "") return;

        const nombres = state.nombres;
        const apellidos = state.apellidos;

        let apiUrl = `${BASEURL}/api/reporte-usuario/planificacion-unidad-periodo/${unidad}/${anio}/${termino}/${page}/${size}`;
        if (nombres && nombres.trim() !== "") {
            apiUrl += `/${encodeURIComponent(nombres.trim())}`;
        }
        if (apellidos && apellidos.trim() !== "") {
            if (!nombres || nombres.trim() === "") apiUrl += `/${encodeURIComponent(" ")}`;
            apiUrl += `/${encodeURIComponent(apellidos.trim())}`;
        }

        const response = await fetch(apiUrl);
        const data = await response.json();

        setLoading(false);
        if (data && data.total && data.datos) {
            setParalelos(data.datos.map(p => ({ ...p, verlista: false, estudiantes: [] })));
            setTotal(data.total);
        } else {
            setParalelos([]);
            setTotal(0);
        }
    };

    useEffect(() => {
        document.title = TITLE + " - Profesores de mi unidad";
        if (currentUser && currentUser !== undefined) {
            populateInitialData(currentUser);
        }
    }, [currentUser]);

    useEffect(() => {
        if (currentUser && currentUser !== undefined) {
            setLoading(true);
            populateData(currentUser);
        }
    }, [state]);

    const handleInputChange = (event) => {
        const name = event.target.name;
        const value = event.target.value;
        const { unidad, anio, termino } = state;
        const page = 1;
        const size = 10;

        if (name === "unidad") {
            props.history.push(`/unidad-evaluacion/${value}/${anio}/${termino}/${page}/${size}`);
            setState(prevState => ({ ...prevState, unidad: value, nombres: "", apellidos: "", page, size }));
        } else if (name === "anio") {
            props.history.push(`/unidad-evaluacion/${unidad}/${value}/${termino}/${page}/${size}`);
            setState(prevState => ({ ...prevState, anio: value, nombres: "", apellidos: "", page, size }));
        } else if (name === "termino") {
            props.history.push(`/unidad-evaluacion/${unidad}/${anio}/${value}/${page}/${size}`);
            setState(prevState => ({ ...prevState, termino: value, nombres: "", apellidos: "", page, size }));
        }
    };

    const handleDocenteInput = (apellidos, nombres) => {
        const { unidad, anio, termino } = state;
        props.history.push(`/unidad-evaluacion/${unidad}/${anio}/${termino}/${1}/${10}`);
        setState({
            ...state,
            apellidos: apellidos == null ? "" : apellidos.trim(),
            nombres: nombres == null ? "" : nombres.trim(),
            page: 1, size: 10
        });
    };

    const handlePage = (url, page, size) => {
        props.history.push(`${url}/${page}/${size}`);
        setState(prevState => ({ ...prevState, page, size }));
    };

    const toggle = (paralelo) => {
        const i = paralelos.indexOf(paralelo);
        if (!paralelo.verlista && paralelo.estudiantes && paralelo.estudiantes.length === 0) {
            MySwal.showLoading();
            fetch(`${BASEURL}/api/reporte-usuario/planificacion-paralelo/${paralelo.anio}/${paralelo.termino}/${paralelo.codigo}/${paralelo.paralelo}/${paralelo.identificacion}`)
                .then(response => response.json())
                .then(data => {
                    MySwal.close();
                    setParalelos(prevParalelos => [
                        ...prevParalelos.slice(0, i),
                        {
                            ...prevParalelos[i],
                            verlista: !prevParalelos[i].verlista,
                            estudiantes: data.datos
                        },
                        ...prevParalelos.slice(i + 1)
                    ]);
                });
        } else {
            setParalelos(prevParalelos => [
                ...prevParalelos.slice(0, i),
                {
                    ...prevParalelos[i],
                    verlista: !prevParalelos[i].verlista,
                },
                ...prevParalelos.slice(i + 1)
            ]);
        }
    };

    const renderTable = (paralelos) => {
        return (
            <>
                <table className='table table-striped' aria-labelledby="tabelLabel">
                    <thead>
                        <tr>
                            <th className="text-center">Año</th>
                            <th className="text-center">Término</th>
                            <th className="text-center">Código</th>
                            <th className="text-center">Materia</th>
                            <th className="text-center">Paralelo</th>
                            <th className="text-center">Docente</th>
                            <th className="text-center">% Respuestas</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {paralelos.map((p, index) => {
                            const porcentaje = p.registrados === 0 ? 0 : Math.round(p.evaluados * 100 / p.registrados);
                            return (
                                <tr key={index}>
                                    <td className="text-center">{p.anio}</td>
                                    <td className="text-center">{p.termino}</td>
                                    <td className="text-center">{p.codigo}</td>
                                    <td>{p.materia}</td>
                                    <td className="text-center">{p.paralelo}</td>
                                    <td>{p.docente}</td>
                                    <td className="text-center">
                                        <span id={"tt_" + index} >{porcentaje}%</span>
                                        <UncontrolledTooltip placement="bottom" target={"tt_" + index}>
                                            {p.evaluados}/{p.registrados}
                                        </UncontrolledTooltip>
                                    </td>
                                    <td>
                                        <Modal isOpen={p.verlista} className="modal-md">
                                            <ModalHeader toggle={() => toggle(p)}>Lista de estudiantes</ModalHeader>
                                            <ModalBody>
                                                <EvaluacionDetalle paralelo={p} estudiantes={p.estudiantes} />
                                            </ModalBody>
                                            <ModalFooter>
                                                <Button color="secondary" onClick={() => toggle(p)}>Cerrar</Button>
                                            </ModalFooter>
                                        </Modal>
                                        <Button onClick={() => toggle(p)}>Detalle</Button>
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                    <tfoot>
                        <tr>
                            <td colSpan={8}>
                                <Paginacion total={total} page={state.page} size={state.size} url={`/unidad-evaluacion/${state.unidad}/${state.anio}/${state.termino}`} handle={handlePage} />
                            </td>
                        </tr>
                    </tfoot>
                </table>
            </>
        );
    };

    const contents = loading ? <p><em>Loading...</em></p> : renderTable(paralelos);

    return (
        <div>
            <h1 id="tabelLabel">Evaluación de mi unidad</h1>
            <UnidadConsulta
                unidadOptions={state.unidades}
                unidadValue={state.unidad}
                anioOptions={state.anios}
                anioValue={state.anio}
                terminoOptions={state.terminos}
                terminoValue={state.termino}
                onInputChange={handleInputChange}
                handleDocenteSubmit={handleDocenteInput}
            />
            {contents}
        </div>
    );
}

export default UnidadEvaluacion;
